import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setPropertyType, setApartmentType } from '../../store/slices/filtersSlice';
import { useTranslation } from '../../utils/translations';
import {
  OFFICE_ADDRESS,
  OFFICE_EMAIL,
  OFFICE_MAP_URL,
  OFFICE_MAP_EMBED,
  OFFICE_PHONE,
  OFFICE_INSTAGRAM_URL,
  OFFICE_FACEBOOK_URL,
} from '../../constants/officeContact';
import { getEmailUrl, getPhoneUrl } from '../../utils/contactHelpers';
import InstagramIcon from '../InstagramIcon/InstagramIcon';
import './Footer.css';

const FOOTER_PROPERTY_TYPES = ['apartment', 'villa', 'office', 'land'];

const Footer = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handlePropertyTypeClick = (propertyType) => {
    dispatch(setPropertyType(propertyType));
    if (propertyType !== 'apartment') {
      dispatch(setApartmentType('all'));
    }
    navigate('/');
    window.setTimeout(() => {
      document.getElementById('properties')?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h4>{t('footer.menu')}</h4>
            <ul>
              <li><Link to="/">{t('header.home')}</Link></li>
              <li><Link to="/">{t('header.properties')}</Link></li>
              <li><Link to="/agents">{t('header.agents')}</Link></li>
              <li><Link to="/offices">{t('header.offices')}</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>{t('footer.propertyTypes')}</h4>
            <ul>
              {FOOTER_PROPERTY_TYPES.map((propertyType) => (
                <li key={propertyType}>
                  <button
                    type="button"
                    className="footer-filter-link"
                    onClick={() => handlePropertyTypeClick(propertyType)}
                  >
                    {t(`propertyTypes.${propertyType}`)}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div className="footer-section">
            <h4>{t('footer.contact')}</h4>
            <p>
              <a href={getPhoneUrl(OFFICE_PHONE)} className="footer-contact-link">
                📞 {OFFICE_PHONE}
              </a>
            </p>
            <p>
              <a href={getEmailUrl(OFFICE_EMAIL)} className="footer-contact-link">
                ✉️ {OFFICE_EMAIL}
              </a>
            </p>
            <p>
              <a
                href={OFFICE_INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="footer-contact-link"
              >
                <InstagramIcon />
                {t('footer.instagram')}
              </a>
            </p>
            <p>
              <a
                href={OFFICE_FACEBOOK_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="footer-contact-link"
              >
                <span className="footer-facebook-icon" aria-hidden="true">f</span>
                {t('footer.facebook')}
              </a>
            </p>
          </div>
          <div className="footer-section footer-location">
            <h4>{t('footer.location')}</h4>
            <div className="footer-map">
              <a
                href={OFFICE_MAP_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={OFFICE_ADDRESS}
              >
                <iframe
                  title={t('footer.location')}
                  src={OFFICE_MAP_EMBED}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  allowFullScreen
                />
              </a>
            </div>
            <p className="footer-address">{OFFICE_ADDRESS}</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2024 Premium Homes. {t('footer.allRightsReserved')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
